var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgGoTo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512",
    width: 20,
    height: 20,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 48c0 26.51-21.5 48-48 48s-48-21.49-48-48 21.5-48 48-48 48 21.49 48 48zM126.5 199.3c-.9.4-1.9.8-2.8 1.2l-11 4.9c-15.29 6.8-27.28 19.2-33.48 34.7l-1.51 3.8c-6.56 16.4-25.18 24.4-41.59 17.8-16.41-6.6-24.39-25.2-17.83-41.6l1.51-3.8c12.39-30.9 36.38-55.8 66.86-69.4l11-4.9c20.84-9.2 42.44-14 66.04-14 44.6 0 84.8 26.8 101.9 67.9l14.5 36.8 22.2 10.7c15.8 7.9 22.2 27.1 14.3 42.9-7.9 15.8-27.1 22.2-42.9 14.3L247 287.3c-10.3-5.2-18.4-13.9-22.8-24.5l-9.6-23-19.3 65.5 49.5 54.1c5.4 5.9 9.3 13 11.2 20.8l23 92c4.3 17.2-6.1 34.6-23.2 38.8-17.2 4.3-34.6-6.1-39.7-23.2l-21.2-88.2-70.6-77.1c-14.8-16.1-21.2-38.6-14.7-59.7l16.9-63.5zM68.73 398l24.96-62.4c2.15 3 4.47 5.8 7.01 8.6l40.7 44.4-14.5 36.2c-2.4 6.1-6 11.6-10.6 16.1l-61.67 61.7c-12.5 12.5-32.76 12.5-45.258 0-12.496-12.5-12.496-32.7 0-45.2L68.73 398z"
  })));
};

export { SvgGoTo as ReactComponent };